import * as React from 'react';

const LinkSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 7v3h1V8h6v8h-6v-2h-1v3h8V7z"
        />
        <path fillRule="evenodd" clipRule="evenodd" d="M7 11.5h10v1H7z" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 7v10h8v-3H9v2H3V8h6v2h1V7H2z"
        />
    </svg>
);

LinkSvg.displayName = 'LinkSvg';
export default LinkSvg;
